import React, { useState } from "react";
import "./TopNav.css";
import { Image, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { logout } from "actions";
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

/** Resolve a display string for role from various API / session shapes */
const getUserRoleLabel = (user) => {
  if (!user || typeof user !== "object") return "";

  const role = user.role;
  if (typeof role === "string" && role.trim()) return role.trim();
  if (role && typeof role === "object") {
    const label = role.name || role.role_name || role.title;
    if (label) return String(label);
  }
  if (typeof user.role_name === "string" && user.role_name.trim()) {
    return user.role_name.trim();
  }
  if (typeof user.user_role === "string" && user.user_role.trim()) {
    return user.user_role.trim();
  }
  if (Array.isArray(user.roles) && user.roles.length > 0) {
    const first = user.roles[0];
    if (typeof first === "string") return first;
    if (first && typeof first === "object") {
      const label = first.name || first.role_name || first.title;
      if (label) return String(label);
    }
  }
  const designationRole = user.designation?.role;
  if (typeof designationRole === "string" && designationRole.trim()) {
    return designationRole.trim();
  }
  return "";
};

const TopNav = () => {
  const dispatch = useDispatch();
  const [showDropdown, setShowDropdown] = useState(false);

  const session = useSelector((state) => state.session);
  const roleLabel = getUserRoleLabel(session.user);

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleLogout = async (event) => {
    event.preventDefault();
    await dispatch(logout());
  };

  return (
    <div className="topNav">
      <Link
        to="/dashboard"
        className="topnav-dashboard-link"
        aria-label="Open dashboard"
        title="Dashboard"
      />
      <Dropdown show={showDropdown} onToggle={handleToggle}>
        <Dropdown.Toggle as="div" id="dropdown-basic" className="cursor-pointer">
          <div className="d-flex justify-content-center align-items-center">
            <Image src="/assets/images/user.svg" className="user-icon" />
            <div className="ms-2">
              <h5 className="font-13 font-weight-medium mb-0 d-flex align-items-center flex-wrap gap-2">
                <span>{!isEmpty(session.user) ? session.user.name : ""}</span>
                {roleLabel ? (
                  <span
                    className="topnav-user-role"
                    title={roleLabel.toUpperCase()}
                  >
                    {roleLabel}
                  </span>
                ) : null}
              </h5>
              <p className="font-13 font-weight-medium mb-0">{!isEmpty(session.user) ? session.user.email : ''}</p>
            </div>
            <Image
              src="/assets/images/dropdown-arrow.svg"
              className={`ms-2 transition-rotate ${showDropdown ? "rotate-180" : ""
                }`}
              alt="Dropdown"
            />
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item onClick={handleLogout}> <Image src="/assets/images/logout-icon.svg" className="me-3" /> Logout</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default TopNav;
